function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["app", "pageType", "onChange"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../../reducers/ppc.reducer';
import Select from '../Select.react';
var SelectPPCLocation = function SelectPPCLocation(_ref) {
  var _ref$app = _ref.app,
    app = _ref$app === void 0 ? '' : _ref$app,
    _ref$pageType = _ref.pageType,
    pageType = _ref$pageType === void 0 ? null : _ref$pageType,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dispatch = useDispatch();
  var locationIndex = useSelector(function (s) {
    return s.ppc.location.index;
  });
  useEffect(function () {
    dispatch({
      type: ppcActions.location,
      payload: {
        formData: {
          app: app
        }
      }
    });
  }, []);
  var lacationArr = Object.values(locationIndex);
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: lacationArr.filter(function (x) {
      return x.clientApp === app;
    }).filter(function (x) {
      if (!pageType) return x;
      return x.type === pageType;
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).map(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        sLabel: x.name,
        sValue: '/' + x.internalUrl
      });
    })
  }, rest, {
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      if (_onChange) _onChange(sValue);
    }
  }));
};
export default SelectPPCLocation;